import React, { useContext } from 'react';
import { Box, Panel, Spinner, theme } from '@xometry/xometry_loft';
import { AuthContext } from '@xometry/auth-context';
import RegistrationHeader from './RegistrationHeader';
import RegistrationForm from './RegistrationForm';

const UnifiedRegistration = () => {
  const { user, isLoading } = useContext(AuthContext);
  if (isLoading) return <Spinner />;

  return (
    <Box width="100%" height="1003px">
      <Panel
        padding={theme.space[0]}
        width={['335px', '600px']}
        marginX="auto"
        marginTop={theme.space[10]}
        paddingTop={theme.space[6]}
      >
        <RegistrationHeader />
        <RegistrationForm userId={user?.id} email={user?.emailAddress} />
      </Panel>
    </Box>
  );
};

export default UnifiedRegistration;
